// /src/store/store.js
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as user from '@/store/modules/user.js'
import * as posts from '@/store/modules/posts.js'
import * as taxies from '@/store/modules/taxies.js'
import * as forms from '@/store/modules/forms.js'
import * as options from '@/store/modules/options.js'
import * as media from '@/store/modules/media.js'
import * as notification from '@/store/modules/notification.js'

Vue.use(Vuex)

// passing URL this so we don't have to change it for requests to work in production
var currentURLObj = new URL(window.location)

export default new Vuex.Store({
  modules: {
    user,
    posts,
    taxies,
    options,
    forms,
    media,
    notification,
  },
  plugins: [
    createPersistedState({
      // paths: ['media', 'posts', 'taxies', 'user'],
      paths: ['user'],
    }),
  ],
  state: {
    headerMenuVisible: false,
    appsMenuVisible: false,
    routeHistory: [],
    backButtonClicked: false,
    backgroundImage: false,
    darkBackground: false,
    headerReverse: false,
    searchInput: '',
    pageClasses: '',
    siteTitle,
    pageTitle: '',
  },
  mutations: {
    SET_HEADER_MENU_VISIBILITY(state, value) {
      state.headerMenuVisible = value
    },
    SET_APPS_MENU_VISIBILITY(state, value) {
      state.appsMenuVisible = value
    },
    ADD_ROUTE_HISTORY(state, value) {
      state.routeHistory = value
    },
    SET_BACK_CLICKED(state, value) {
      state.backButtonClicked = value
    },
    SET_BACKGROUND_IMAGE(state, value) {
      state.backgroundImage = value
    },
    SET_DARK_BACKGROUND(state, bool) {
      state.darkBackground = bool
    },
    SET_REVERSE_HEADER(state, bool) {
      state.headerReverse = bool
    },
    SET_SEARCH_INPUT(state, value) {
      state.searchInput = value
    },
    SET_PAGE_CLASSES(state, value) {
      state.pageClasses = value
    },
    SET_PAGE_TITLE(state, value) {
      state.pageTitle = value
    },
  },
  actions: {
    toggleHeaderMenu({ commit }) {
      if (this.getters.headerMenuVisible) {
        commit('SET_HEADER_MENU_VISIBILITY', false)
      } else {
        commit('SET_HEADER_MENU_VISIBILITY', true)
      }
    },

    toggleAppsMenu({ commit, state }) {
      if (this.getters.appsMenuVisible) {
        commit('SET_APPS_MENU_VISIBILITY', false)
        document.body.classList.remove("menu--active");
        if (state.backgroundImage === false) {
          commit('SET_REVERSE_HEADER', false)}
      } else {
        commit('SET_APPS_MENU_VISIBILITY', true)
        document.body.classList.add("menu--active");
        if (state.backgroundImage === false) commit('SET_REVERSE_HEADER', true)
      }
    },

    updatePageClasses({ commit }, value) {
      commit('SET_PAGE_CLASSES', value)
    },

    updateSearchInputValue({ commit }, value) {
      commit('SET_SEARCH_INPUT', value)
    },

    updateBackgroundDark({ commit }, bool) {
      commit('SET_DARK_BACKGROUND', bool)  
    },

    updateHeaderRev({ commit }, bool) {
      commit('SET_REVERSE_HEADER', bool)  
    },

    updateRouteHistory({ commit, state }, routeInfo) {
      let { routeHistory } = state
      routeHistory.unshift(routeInfo)
      commit('ADD_ROUTE_HISTORY', routeHistory)
    },

    removeLastFromRouteHistory({ commit, state }) {
      let { routeHistory } = state
      routeHistory.shift()
      commit('ADD_ROUTE_HISTORY', routeHistory)
    },

    openMenu({ commit, state }, { mutationItem }) {
      commit(mutationItem, true)
    },

    closeMenu({ commit, state }) {
      commit('SET_APPS_MENU_VISIBILITY', false)
      commit('SET_HEADER_MENU_VISIBILITY', false)
      if (state.backgroundImage === false) commit('SET_DARK_BACKGROUND', false)  
    },

    isBackButtonClicked({ commit }, bool) {
      commit('SET_BACK_CLICKED', bool)
    },

    updateBackgroundImage({ commit }, bgImage) {
      if (bgImage !== false) {
        commit('SET_BACKGROUND_IMAGE', bgImage)
        commit('SET_DARK_BACKGROUND', true)  
        commit('SET_REVERSE_HEADER', true)  
      } else {
        commit('SET_BACKGROUND_IMAGE', bgImage)
      }
    },

    updatePageTitle({ commit, state }, title) {
      commit('SET_PAGE_TITLE', state.siteTitle + ' | ' + title)
    },

  },
  getters: {
    headerMenuVisible(state) {
      return state.headerMenuVisible
    },
    appsMenuVisible(state) {
      return state.appsMenuVisible
    },
    getRouteHistory(state) {
      return state.routeHistory
    },
    backButtonClicked(state) {
      return state.backButtonClicked
    },
    getBackgroundImage(state) {
      return state.backgroundImage
    },
    getHeaderRevState (state) {
      return state.headerReverse
    },
    getSearchInputValue(state) {
      return state.searchInput
    },
    getPageClasses(state) {
      return state.pageClasses
    },
    checkBgDark(state) {
      return state.darkBackground
    },
    siteTitle(state) {
      return state.siteTitle
    },
    pageTitle(state) {
      return state.pageTitle !== '' ? state.pageTitle : state.siteTitle
    },
  },
})
